import { HorizontalDividerContainer } from './horizontal-divider.styled';

export const HorizontalDivider = ():JSX.Element =>  <HorizontalDividerContainer />;
